import { z } from 'zod'

export const validationSchema = z.object({
  login: z
    .string({ required_error: 'Login é obrigatório' })
    .min(1, 'Login é obrigatório'),
  password: z
    .string({ required_error: 'Senha é obrigatória' })
    .min(8, 'Digite no mínimo 8 caracteres')
    .max(128, 'Digite no máximo 128 caracteres')
    .regex(/^\S*$/, 'Senha não pode conter espaços')
})

export type SignInSchema = z.infer<typeof validationSchema>
